<template>
  <div class="confirm-modal__buttons">
    <button
      class="confirm-modal__button"
      type="button"
      v-on:click="onCancel">{{cancelTitle}}</button>
    <button
      class="confirm-modal__button negative"
      type="button"
      v-on:click="onConfirm">{{confirmTitle}}</button>
  </div>
</template>

<script>
/**
 * @description Наименование события подтверждения.
 * @type {string}
 */
const EVENT_NAME_CONFIRM = 'on-confirm';

/**
 * @description Наименование события отмены.
 * @type {string}
 */
const EVENT_NAME_CANCEL = 'on-cancel';

export default {
  /**
   * @description Модальное окно подтверждения.
   */
  name: 'ConfirmModal',
  props: {
    /**
     * @description Заголовок кнопки отмены.
     * @type {String}
     */
    cancelTitle: {
      type: String,
      required: true,
    },
    /**
     * @description Заголовок кнопки подтверждения.
     * @type {String}
     */
    confirmTitle: {
      type: String,
      required: true,
    },
  },
  methods: {
    /**
     * @description Обработать событие отмены.
     * @returns {void}
     */
    onCancel() {
      this.$emit(EVENT_NAME_CANCEL);
    },
    /**
     * @description Обработать событие подтверждения.
     * @returns {void}
     */
    onConfirm() {
      this.$emit(EVENT_NAME_CONFIRM);
    },
  },
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";
.confirm-modal {
  &__buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 10px 0 0 0;
  }
  &__button {
    @include buttons.btn-transparent(100%, 30px, 16px);
    &.negative {
      border: 1px solid rgba(224, 4, 4, 0.97);
      color: rgba(224, 4, 4, 0.97);
    }
  }
  &__img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
    margin: 15px 0;
  }
}
</style>
